import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../organisms';

import styles from './ConfirmationTemplate.module.scss';

export interface IConfirmationTemplate {
	label: string;
	text: string;
	onHome: () => void;
}

export const ConfirmationTemplate = (props: IConfirmationTemplate) => {
	const { t } = useTranslation();

	return (
		<div className={styles.globalDihkFont + ' ' + styles.pageContent}>
			<Header label={t('header.label')} onClick={props.onHome} />
			<div className={styles.message}>
				<h1>{props.label}</h1>
				<p>{props.text}</p>
			</div>
		</div>
	);
};
